export default {
  getCriterios: (state) => state.criterios,
  getCriterioByIndex: (state) => (index) => state.criterios[index],
  getItemIdByIndex: (state) => (index) => state.criterios[index].itemId,
  getErros: (state) => {
    return state.erros
  }
}